
type props = {
  children: React.ReactNode
} & ((React.ComponentPropsWithoutRef<'h1'>))

export function H1({ className, children }: props) {
  return (
    <h1 className={className}>
      {children}
      <div className='pt-1 border-b-4 border-red-800 w-8' />
    </h1>
  )
}